import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import { DemoModeProvider } from './contexts/DemoModeContext'
import { LoginPage } from './components/auth/LoginPage'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import ProsecutorAnalyticsApp from './components/ProsecutorAnalyticsApp'
import { UpdateNotification } from './components/common/UpdateNotification'
import { DebugConsole } from './components/common/DebugConsole'

function LoginRedirect() {
  const location = useLocation()
  const from = location.state?.from
  const redirectPath = from?.pathname || '/base'
  const searchString = from?.search || ''
  return <Navigate to={redirectPath + searchString} replace />
}

function App() {
  const {
    login,
    loginWithFace,
    loginWithToken,
    isAuthenticated,
    isTestModeAuth,
  } = useAuth()

  return (
    <DemoModeProvider>
      {/* Уведомление о новой версии */}
      <UpdateNotification />

      {/* Debug консоль для iPad (тройной тап в правом нижнем углу) */}
      <DebugConsole />

      <div>
        <Routes>
          <Route path="/ai-results" element={<Navigate to="/administration-ai-results" replace />} />
          <Route path="/" element={<Navigate to="/base" replace />} />
          <Route path="/dashboard-v2" element={<Navigate to="/base" replace />} />
          {/*
           * Правительственные поручения сняты 27.09.2026 — на планшете остались
           * только поручения акима. Без перенаправления закладка на старый
           * адрес открывала бы пустой экран: список разделов в приложении не
           * ведётся, неизвестный раздел просто ничего не рисует.
           */}
          <Route path="/gg-assignments" element={<Navigate to="/tasks-v2" replace />} />
          <Route
            path="/login"
            element={
              isAuthenticated || isTestModeAuth ? (
                <LoginRedirect />
              ) : (
                <LoginPage
                  onLogin={login}
                  onLoginWithFace={loginWithFace}
                  onLoginWithToken={loginWithToken}
                />
              )
            }
          />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <ProsecutorAnalyticsApp />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </DemoModeProvider>
  )
}

export default App
//
/*
 * Тестовые логин и пароль лежат в `src/constants/testAuth.ts`, а не здесь:
 * этот файл импортирует `AuthContext`, который их читает, — вышел бы цикл, и на
 * старте значения были бы `undefined`. Форма их не подставляет, а тестовый
 * вход работает только в dev-сборке.
 */
